import Vue from 'vue'
import App from './App.vue'
import router from './router'
import 'lib-flexible/flexible'
import './assets/css/index.css'
import store from './store'
import moment from 'moment'
Vue.prototype.moment = moment
Vue.config.productionTip = false
Vue.prototype.store = store

import { Col, Row, Swipe, SwipeItem, Tab, Tabs, PullRefresh, Button, Field, Form, Toast, List, DatetimePicker, Popup, Cell, CellGroup, Picker, Dialog, Icon, Circle, RadioGroup, Radio, Uploader, Progress, Checkbox, Empty, NavBar, Loading } from 'vant';
Vue.use(Col);
Vue.use(Row)
Vue.use(Swipe);
Vue.use(SwipeItem);
Vue.use(Tab);
Vue.use(Tabs);
Vue.use(PullRefresh);
Vue.use(Button);
Vue.use(Field);
Vue.use(Form);
Vue.use(Toast);
Vue.use(List);
Vue.use(DatetimePicker);
Vue.use(Popup);
Vue.use(Cell);
Vue.use(CellGroup);
Vue.use(Picker);
Vue.use(Dialog);
Vue.use(Icon);
Vue.use(Circle);
Vue.use(Radio);
Vue.use(RadioGroup);
Vue.use(Uploader);
Vue.use(Progress);
Vue.use(Checkbox);
Vue.use(Empty);
Vue.use(NavBar);
Vue.use(Loading);



import VueCanvasPoster from 'vue-canvas-poster'
Vue.use(VueCanvasPoster)
// import VConsole from 'vconsole';
// if (process.env.VUE_APP_MODE !== 'production') {
//   const vConsole = new VConsole()
//   Vue.use(vConsole);
// }

import { getLoginInfo } from '@/api/index.js'
import { getToken } from '@/utils/auth'
import {
  parseOpenIdFromBadBindHash,
  getBindOpenId,
  isBindRoute,
  normalizeUrlToken,
  triggerWxLoginByRedirect
} from '@/utils/wx-auth'


// 定义全局时间戳过滤器
Vue.filter('formatDate', function(value) {
  return moment(value).format('YYYY-MM-DD')
})

import VideoPlayer from 'vue-video-player/src';
import 'vue-video-player/src/custom-theme.css'
import 'video.js/dist/video-js.css'
Vue.use(VideoPlayer)


function loadUserInfo() {
  return getLoginInfo()
    .then(res => {
      if (res.data) {
        const userInfo = {
          id: res.data.id || '',
          name: res.data.name || '',
          account: res.data.account || '',
          avatar: res.data.avatar || '',
          idCard: res.data.idCard || '',
          phone: res.data.phone || '',
          medicalName: res.data.medicalName || res.data.hospital || '',
          workingState: res.data.workingState || res.data.type || '',
          work: res.data.work || ''
        }
        setUserInfoCache(userInfo)
      }
    })
    .catch(err => {
      console.error('获取用户信息失败:', err)
    })
}


import { setToken, clearWxMpAppId, setUserInfoCache } from '@/utils/auth'
router.beforeEach((to, from, next) => {
  if (process.env.NODE_ENV === 'development') {
    setToken('5e44ed41-43cd-4d12-8ea7-9cb68b95bc23')
  }
  if (to.meta.title) {
    document.title = to.meta.title
  }
  if (to.meta.navIndex) {
    store.commit('getNavIndex', to.meta.navIndex)
  }
  if (normalizeUrlToken(to, next)) {
    return
  }
  const badHashOpenId = parseOpenIdFromBadBindHash()
  if (badHashOpenId) {
    if (to.name !== 'bind' || String(to.query.openId || '') !== String(badHashOpenId)) {
      next({ name: 'bind', query: { openId: badHashOpenId }, replace: true })
      return
    }
  }
  if (to.query.code) {
    const { code, state, ...queryRest } = to.query
    loadUserInfo().finally(() => {
      next({
        path: to.path,
        query: queryRest,
        hash: to.hash,
        replace: true
      })
    })
    return
  }
  if (getToken()) {
    next()
    return
  }
  const bindOpenId = getBindOpenId(to)
  if (isBindRoute(to) && bindOpenId) {
    next()
    return
  }
  triggerWxLoginByRedirect()
    .then(() => {})
    .catch(() => {
      next()
    })

})

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
